<template>
  <section id="section-2" class="content-current">
    <div class="row">
      <div class="col-md-11"></div>
      <div class="col-md-1">
        <router-link to="/profile/dashboard">
          <div title="بازگشت به داشبورد" class="close"></div>
        </router-link>
      </div>
    </div>
    <form>
      <!-- <div class="row">
        <div class="col-md-12">
          <h4>اطلاعات تکمیلی</h4>
        </div>
      </div> -->
      <div v-for="(line, index) in lines" :key="index">
        <!-- End row -->

        <div class="row">
          <div class="col-md-5">
            <div class="select">
              <select class="select-text" v-model="line.contactType">
                <option v-for="item in contactTypes" :value="item.key" :key="item.key">
                  {{ item.value }}
                </option>
              </select>
              <span class="select-highlight"></span>
              <span class="select-bar"></span>
              <label class="select-label">نوع</label>
            </div>
          </div>

          <div class="col-md-5">
            <div class="group_mdi">
              <input v-model="line.value" />
              <span data-v-378b8112="" class="highlight"></span><span data-v-378b8112="" class="bar"></span>
              <label>مقدار</label>
            </div>
          </div>
          <i style="
              margin-top: 38px;
              font-size: 25px;
              margin-right: 20px;
              color: rgb(0, 132, 137);
            " class="icon-plus-2" @click.prevent="addLine()" title="افزودن ردیف"></i>

          <i class="icon-trash-2 icon-top remove-color" @click.prevent="removeLine(index)" title="حذف ردیف"></i>
        </div>
      </div>
      <hr />
      <div class="btn-align">
        <button type="submit" class="btn btn-primary" @click.prevent="save" v-if="!isEditMode">
          ثبت
        </button>
        <button type="submit" class="btn btn-primary" @click.prevent="edit" v-if="isEditMode">
          ویرایش
        </button>
      </div>
    </form>
  </section>
</template>

<script>
import store from "../../views/profile/store/index";
export default {
  name: "CompletionInfo",
  store: store,
  data() {
    return {
      lines: [],
      blockRemoval: true,
      contactType: "",
      value: "",
      profileId: "",
      profileContactList: [],

      contactTypes: [
        { key: 6, value: "تلفن ثابت" },
        { key: 7, value: "آدرس" },
        { key: 1, value: "ایمیل" },
        { key: 2, value: "موبایل" },
        { key: 3, value: "تلفن منزل" },
        { key: 4, value: "تلفن محل کار" },
        { key: 5, value: "فکس" },
      ],
      isEditMode: false,
    };
  },
  watch: {
    lines() {
      this.blockRemoval = this.lines.length <= 1;
    },
  },
  methods: {
    async getUserId() {
      await this.$store.dispatch("getUserId").then(() => {
        this.profileId = this.$store.getters.GetUserId;

        this.fetchData(this.profileId);
      });
    },
    addLine() {
      let checkEmptyLines = this.lines.filter((line) => line.number === null);

      if (checkEmptyLines.length >= 1 && this.lines.length > 0) {
        return;
      }

      this.lines.push({
        contactType: this.contactType,
        value: this.value,
        profileId: this.profileId,
      });
    },

    removeLine(lineId) {
      if (!this.blockRemoval) {
        this.lines.splice(lineId, 1);
      }
    },

    removeEmptyLine(lineId) {
      this.lines.splice(lineId, 1);
    },

    async fetchData() {
      this.profileContactList = await this.$store
        .dispatch("GetProfileContact", this.profileId)
        .then((res) => {
          if (res.length > 0) {
            this.removeEmptyLine(0);
            res.forEach((element) => {
              this.contactType = element.contactType;
              this.value = element.value;

              this.addLine();

              this.contactType = "";
              this.value = "";
              this.isEditMode = true;
            });
          } else {
            this.contactType = "";
            this.value = "";
            this.addLine();

            this.isEditMode = false;
          }
        });
    },

    async save() {
      const res = await this.$store.dispatch("InsertProfileContact", {
        porofileContactList: this.lines,
        profileId: this.profileId,
      });
      if (res.status == 200) {
        // alert("ثبت اطلاعات با موفقیت انجام گردید");
        this.$toast.success("ثبت اطلاعات با موفقیت انجام گردید", {
          position: "top-center",
          timeout: 4500,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 1.59,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          icon: true,
          rtl: true,
        });
      }


    },

    async edit() {
      const res = await this.$store.dispatch("UpdateProfileContact", {
        porofileContactList: this.lines,
        profileId: this.profileId,
      });

      if (res.status == 200) {
        // alert("ویرایش اطلاعات با موفقیت انجام گردید");
        this.$toast.success("ویرایش اطلاعات با موفقیت انجام گردید", {
          position: "top-center",
          timeout: 4500,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 1.59,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          icon: true,
          rtl: true,
        });
      }
    },
  },
  mounted() {
    this.getUserId();
  },
};
</script>
<style scoped>
.select {
  background: white !important;
  outline: none !important;
  color: #ced4da !important;
}

.styled-select select {
  padding: 7px 15px 5px 5px;
  width: 100%;
  color: #333;
}

.styled-select {
  background: #ffffff url(../../../public/img/down_arrow_select.png) no-repeat left center !important;
}

.icon-top {
  margin-top: 38px;
  font-size: 25px;
  margin-right: 20px;
}

.add-color {
  color: #64d3e8;
}

.remove-color {
  color: red;
}
</style>